﻿export class ShareXHelper_ABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "shareXAdr_",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "shareOwner_",
				"type": "address"
			},
			{
				"internalType": "address[]",
				"name": "tokens_",
				"type": "address[]"
			}
		],
		"name": "getShareXInfo",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "share_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalShare_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "ethCalc_",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "ethClaim_",
				"type": "uint256"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "forCalc",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "forClaim",
						"type": "uint256"
					}
				],
				"internalType": "struct ShareXHelper.ShareInfo[]",
				"name": "info_",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
    }
}